interface IArgumentsListProps {
  children: React.ReactNode;
}

const ArgumentsList: React.FC<IArgumentsListProps> = ({ children }) => {
  return <ul className="tw-lf-bullet-list tw-mt-0">{children}</ul>;
};

export default ArgumentsList;
